import { Settings } from "common";
import en from "i18n/en.json";
import hu from "i18n/hu.json";

const settings: Settings = {
  apiHost: process.env.REACT_APP_API_HOST,
  webHost: process.env.REACT_APP_WEB_HOST,
  requestTimeout: 60000,
  loginUrl: "/user/login",
  refreshTokenUrl: "",
  logoutUrl: "/user/logout",
  refreshTokenDeltaTime: 1800,
  refreshTokenNotificationDeltaTime: 600,
  i18n: {
    fallbacks: true,
    locale: "en-US", //navigator.language, //"hu-HU",
    defaultLocale: "en-US",
    translations: { en, hu },
    moment: {
      week: {
        dow: 1, // Monday is the first day of the week.
      },
    },
  },
  constants: {
    autoColorOpacity: 0.3,
  },
};

export default settings;
